

import {  
  loadEventLogDataInProgress,
  loadEventLogDataSuccess,
  loadEventLogDataFailure,
  eventLogOperationCompleted
} from "../state/eventlogfiles/actions";
import { oktaAuth } from '../auth/okta';
import configData from "../config.json";
import { errorSweetAlert } from "../components/SweetAlertMessages";
const serverBasePath=configData.SERVER_API_URL;
let abortController = null;

export const loadEventLogFiles = (serialNumber,searchBy) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
      dispatch(loadEventLogDataInProgress());
      const response = await fetch(serverBasePath+"/file/eventLogFiles?serialNumber="+serialNumber+"&searchBy="+searchBy,
      {  
        signal, 
        method: "GET",
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        }
      });
      
      if(response.status===401){
        window.location.reload(false);
        return;
      }
      const data = await response.json();
      dispatch(loadEventLogDataSuccess(data));    
    } catch (e) {
      dispatch(loadEventLogDataFailure());   
      if (e.name === "AbortError") {
        //errorSweetAlert({message:'The operation was aborted.'}); 
      }
    }
};

export const downloadEventLogFile = (rowId,fileName) =>  {
  return async (dispatch) => {
      const token = oktaAuth.getAccessToken();
      if (!token) throw new Error('No access token');
      try {
          dispatch(loadEventLogDataInProgress());
          const response = await fetch(serverBasePath+"/file/"+rowId+"/eventLogs/download",{
          method: "GET",
          headers: {
              Authorization: 'Bearer ' + token,
          }});
          if(response.status === 500){
            dispatch(loadEventLogDataFailure());
            dispatch(errorSweetAlert('Internal Server Error'));
            return
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',fileName); 
          document.body.appendChild(link);
          link.click();
          dispatch(eventLogOperationCompleted()); 
      } catch (e) {   
          dispatch(loadEventLogDataFailure());
          errorSweetAlert(e)
      }
  };
};